import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { companyInfo } from '../mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-950 border-t border-gold/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_abudhabi-heavygear/artifacts/ehlf0vwr_finallogo.png" 
              alt={companyInfo.shortName}
              className="h-14 w-auto object-contain"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Leading provider of heavy equipment rental and transport services in Abu Dhabi, UAE.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gold font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-gold transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-gold transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-gold transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/fleet" className="text-gray-400 hover:text-gold transition-colors text-sm">
                  Our Fleet
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-gold transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-gold font-bold text-lg mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Forklift Rental</li>
              <li>Excavator Services</li>
              <li>Mobile Crane</li>
              <li>Bobcat / JCB</li>
              <li>Boom Loader</li>
              <li>Transport Services</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-gold font-bold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-sm">
                <MapPin className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
                <div className="text-gray-400">
                  <span>Central Tower 20, Office 44</span><br />
                  <span>Al Bateen, Abu Dhabi, UAE</span>
                </div>
              </li>
              <li className="flex items-start space-x-3 text-sm">
                <Phone className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
                <div className="text-gray-400 space-y-1">
                  {companyInfo.contact.phones.slice(0, 2).map((phone, index) => (
                    <div key={index}>
                      <a href={`tel:${phone}`} className="hover:text-gold transition-colors">
                        {phone}
                      </a>
                    </div>
                  ))}
                </div>
              </li>
              <li className="flex items-start space-x-3 text-sm">
                <Mail className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
                <a 
                  href={`mailto:${companyInfo.contact.email}`}
                  className="text-gray-400 hover:text-gold transition-colors break-all"
                >
                  {companyInfo.contact.email}
                </a>
              </li>
              <li className="flex items-start space-x-3 text-sm">
                <Clock className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
                <span className="text-gray-400">24/7 Service Available</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm text-center md:text-right">
              Heavy Equipment Rental | Abu Dhabi, UAE
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;